import { Box, Grid } from '@mui/material';
import { Field, FieldProps, FormikProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Media, UploadState, UploadType } from '@synergy/models';
import { PaloLinkRow } from '@synergy/components-palo';
import { PoolDropzone, PoolFileList, PoolTextArea, PoolTypography } from '@synergy/components';

import { DemandAccount } from '../../../../../models/demand-account';
import { useAppSelector } from '../../../../../../../store/use-appstate-selector';

export const FeedbackInternalNotes = () => {
    const mediaBaseUrl = useAppSelector(state => state.settings.mediaBaseUrl);

    const handleFileDrop = (form: FormikProps<DemandAccount>) => (acceptedFiles: File[]) => {
        const existingMedia = form.values.media;

        const deduplicated = acceptedFiles.filter(
            acceptedFile =>
                !existingMedia.some(
                    media => media.originalName === acceptedFile.name && media.size === acceptedFile.size
                )
        );

        const newMedia = deduplicated.map(file => Media.fromFile(file, UploadType.Internal));
        newMedia.forEach(media => (media.state = UploadState.Finished));
        form.setFieldValue('media', existingMedia.concat(newMedia));
    };

    const handleFileRemove = (form: FormikProps<DemandAccount>) => (media: Media) => {
        const existingMedia = form.values.media;

        const index = existingMedia.findIndex(m => m.id === media.id);
        if (index >= 0) {
            const newMedia = [...existingMedia];
            newMedia.splice(index, 1);
            form.setFieldValue('media', newMedia);
        }
    };

    return (
        <Box sx={{ pr: 3 }}>
            <PoolTypography styleType="sectionTitle" id="app.header.internalNote" />
            <Grid container={true} spacing={2} direction="column" alignItems="flex-end">
                <Grid item={true} container={true} xs={12} direction="row">
                    <Grid item={true} xs={7} sx={{ pr: 1 }}>
                        <Field name="internalNote">
                            {({ field }: FieldProps<DemandAccount>) => (
                                <>
                                    <PoolTextArea
                                        label={<FormattedMessage id="app.label.note" />}
                                        rows="5"
                                        rowsMax="50"
                                        {...field}
                                    />
                                    <PaloLinkRow text={String(field.value ?? '')} />
                                </>
                            )}
                        </Field>
                    </Grid>
                    <Grid item={true} xs={5} sx={{ pl: 1 }}>
                        <Field>
                            {({ form }: FieldProps<DemandAccount>) => {
                                return (
                                    <Grid container={true} spacing={3}>
                                        <Grid item={true} xs={12}>
                                            {/* No "save first" here: the dialog
                                                only opens on a report that
                                                exists, and the hint read on
                                                every one of them because the
                                                form never carried an id
                                                (#2215, R-75). */}
                                            <PoolDropzone onDrop={handleFileDrop(form)} />
                                        </Grid>
                                        <Grid item={true} xs={12}>
                                            <PoolFileList
                                                // TODO: refactor map
                                                acceptedFiles={(form.values.media as Media[])
                                                    .filter(file => file.type === UploadType.Internal)
                                                    .map(file => ({
                                                        ...file,
                                                        state: file.state || UploadState.Finished,
                                                    }))}
                                                onDeleteClicked={handleFileRemove(form)}
                                                downloadBaseUrl={mediaBaseUrl}
                                            />
                                        </Grid>
                                    </Grid>
                                );
                            }}
                        </Field>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};
